export default "__VITE_ASSET__CsGJPaSc__"